"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var env = process.env.VUE_APP_BASE_DEPLOY; // pack env
var _default = exports.default = {
  _default: {
    serverUrl: env === 'vessel' ? '' : 'sys/',
    projectKey: 'csmp',
    serviceCode: 'NJTC',
    excelImportConfig: {
      filter: 'csv,xls,xlsx',
      // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  },
  comClient: {
    serverUrl: env === 'vessel' ? '' : 'com/',
    projectKey: 'csmp',
    serviceCode: env === 'vessel' ? 'IMMP' : 'com',
    excelImportConfig: {
      filter: 'csv,xls,xlsx',
      // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  },
  opsClient: {
    serverUrl: env === 'vessel' ? '' : 'ops/',
    projectKey: 'csmp',
    serviceCode: env === 'vessel' ? 'IMMP' : 'ops',
    excelImportConfig: {
      filter: 'csv,xls,xlsx',
      // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  },
  poolClient: {
    serverUrl: env === 'vessel' ? '' : 'pool/',
    projectKey: 'csmp',
    serviceCode: env === 'vessel' ? 'IMMP' : 'pool',
    excelImportConfig: {
      filter: 'csv,xls,xlsx',
      // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  },
  chrClient: {
    serverUrl: env === 'vessel' ? '' : 'chr/',
    projectKey: 'csmp',
    serviceCode: env === 'chr' ? 'IMMP' : 'chr',
    excelImportConfig: {
      filter: 'csv,xls,xlsx',
      // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  },
  finClient: {
    serverUrl: env === 'vessel' ? '' : 'fin/',
    projectKey: 'csmp',
    serviceCode: env === 'vessel' ? 'IMMP' : 'fin',
    excelImportConfig: {
      filter: 'csv,xls,xlsx',
      // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  },
  pchClient: {
    serverUrl: env === 'vessel' ? '' : 'pch/',
    projectKey: 'csmp',
    serviceCode: env === 'vessel' ? 'IMMP' : 'pch',
    excelImportConfig: {
      filter: 'csv,xls,xlsx',
      // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  },
  bmsClient: {
    serverUrl: env === 'vessel' ? '' : 'bms/',
    projectKey: 'csmp',
    serviceCode: env === 'vessel' ? 'IMMP' : 'bms',
    excelImportConfig: {
      filter: 'csv,xls,xlsx',
      // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  },
  rptClient: {
    serverUrl: env === 'vessel' ? '' : 'vrt/',
    projectKey: 'csmp',
    serviceCode: env === 'vessel' ? 'IMMP' : 'rpt',
    excelImportConfig: {
      filter: 'csv,xls,xlsx',
      // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  },
  fiClient: {
    serverUrl: env === 'vessel' ? '' : 'fi/',
    projectKey: 'csmp',
    serviceCode: env === 'vessel' ? 'IMMP' : 'fi',
    excelImportConfig: {
      filter: 'csv,xls,xlsx',
      // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  },
  cpmClient: {
    serverUrl: env === 'vessel' ? '' : 'cpm/',
    projectKey: 'csmp',
    serviceCode: env === 'vessel' ? 'IMMP' : 'cpm',
    excelImportConfig: {
      filter: 'csv,xls,xlsx',
      // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  },
  book: {
    serverUrl: env === 'vessel' ? '' : 'book/',
    projectKey: 'csmp',
    serviceCode: env === 'vessel' ? 'IMMP' : 'book',
    excelImportConfig: {
      filter: 'csv,xls,xlsx',
      // 文件类型过滤器
      maxsize: 10 // 文件上传大小限制，单位：M
    }
  }
};